
import { withTranslation } from "react-i18next";
import {
  Navbar, Navlinks, Contact, Anchortag, FooterMap, FooterMapRow, FooterUtilityRow, Email, Twitter, Column,
  FooterUtility, SpanList
} from "./styles";
import React, { useState, ChangeEvent, useContext } from 'react';
import { Grid } from "@material-ui/core";
import { SvgIcon } from "../../common/SvgIcon";
import { LangContext } from '../../context/UserContext';
import Container from '../../common/Container';


interface SocialLinkProps {
  href?: string;
  src?: string;
  t?: any
}

const Footer = (props: SocialLinkProps) => {
  const languageCheck: any = useContext(LangContext);
  return (
    <>
      <Navbar>
        <Navlinks isArabic={languageCheck.language}>
          <ul>
            {/* <Grid container>
              <Grid item lg={6} md={6} xs={12}> */}
               <li> <Contact>
                  <SvgIcon src="contact.png" width="23px" height="26px" />
                  {/* <Anchortag href="tel:800 124 8888">Inside the kingdom : 800 124 8888</Anchortag> */}
                  <SpanList isArabic={languageCheck.language}>{props.t("FOOTER_INS_KING")}</SpanList> : <Anchortag href="tel:800 124 8888">800 124 8888</Anchortag>
                </Contact>
                </li>
              {/* </Grid> */}
              {/* <Grid item lg={6} md={6} xs={12}> */}
              <li>
                <Contact>
                  <SvgIcon src="contact.png" width="23px" height="26px" />
                  {/* <Anchortag href="tel:+966114062800">Outside the kingdom : +966114062800</Anchortag> */}
                  <SpanList isArabic={languageCheck.language}>{props.t("FOOTER_OUT_KING")}</SpanList> : <Anchortag href="tel:+966114062800">+966114062800</Anchortag>
                </Contact>
                </li>
              {/* </Grid>
            </Grid> */}
          {/* </ul>
          <ul> */}
            {/* <Grid container >
              <Grid item lg={6} md={6} xs={12}> */}
              <li>
                <Email>
                  <SvgIcon src="email-icon.png" width="24px" height="24px" />
                  {/* <Anchortag href="mailto:sabb@sabb.com">Email :sabb@sabb.com</Anchortag> */}
                  <SpanList isArabic={languageCheck.language}>{props.t("Email")}</SpanList> : <Anchortag href="mailto:feedback@sab.com">feedback@sab.com</Anchortag>
                </Email>
                </li>
              {/* </Grid>
              <Grid item lg={6} md={6} xs={12}> */}
              <li>
                <Twitter>
                  <SvgIcon src="Twitter.png" width="23px" height="24px" />
                  {/* <Anchortag href="https://twitter.com/sabb_ecare?land=en" target="_blank">Twitter : eCaresabb</Anchortag> */}
                  <Anchortag isArabic={languageCheck.language} href="https://x.com/alawwalsabcare" target="_blank">SABcare</Anchortag>
                </Twitter>
                </li>
              {/* </Grid>
            </Grid> */}
          </ul>

        </Navlinks>
      </Navbar>
      {/* <FooterMap isArabic={languageCheck.language}>
        <FooterMapRow>
          <Column isArabic={languageCheck.language}>
            <h2>
              <a href="http://www.sabb.com/en/everyday-banking/" title="Everyday banking" target="_blank"> {props.t("FOOTER_EVERYDAY_BNK")}</a></h2>
            <ul>
              <li>
                <a href="http://www.sabb.com/en/everyday-banking/accounts/" title="Accounts" target="_blank">{props.t("Accounts")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/everyday-banking/" title="Private Banking Services" target="_blank">{props.t("FOOTER_PVT_BNK_SRVC")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/everyday-banking/compare-credit-cards/" title="Compare Credit Cards" target="_blank">{props.t("FOOTER_CMPR_CC")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/everyday-banking/debit-card/sabb-debit-card/" title="SABB Debit Card" target="_blank">{props.t("FOOTER_SAB_DC")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/everyday-banking/prepaid-card/sabb-household-salary-card/" title="Prepaid Card" target="_blank">{props.t("FOOTER_PC")}</a></li>
              <li>
                <a href="https://www.sabbnet.com/1/PA_1_083Q9FJ08A002FBP5S00000000/content/common/IBAN/index.html" title="Generate IBAN" target="_blank">{props.t("FOOTER_GEN_IBAN")}</a>
              </li>
            </ul>
          </Column>
          <Column isArabic={languageCheck.language}>
            <h2>
              <a href="http://www.sabb.com/en/wealth-management/" title="Wealth Management" target="_blank">{props.t("FOOTER_WELTH_MGMT")}</a></h2>
            <ul>
              <li>
                <a href="http://www.sabb.com/en/wealth-management/wealth-management-solutions/" title="Wealth Management Solutions" target="_blank">{props.t("FOOTER_WELTH_MGMT_SOLN")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/everyday-banking/accounts/" title="Banking Services" target="_blank">{props.t("FOOTER_BANKING_SERVS")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/wealth-management/wealth-management-solutions/" title="Investment Solutions" target="_blank">{props.t("FOOTER_INVST_SOLN")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/wealth-management/wealth-management-solutions/" title="SABB Takaful Solutions" target="_blank">{props.t("FOOTER_SAB_TKFL_SOLN")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/wealth-management/wealth-management-solutions/" title="Wide Range Asset Classes" target="_blank">{props.t("FOOTER_ASST_CLSS")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/wealth-management/safe-deposit-lockers/" title="Safe Deposit Lockers" target="_blank">{props.t("FOOTER_SAFE_DEPOST")}</a></li>
            </ul>
          </Column>
          <Column isArabic={languageCheck.language}>
            <h2>
              <a href="http://www.sabb.com/en/financing/" rel="noopener" title="Financing" target="_blank">{props.t("Financing")}</a></h2>
            <ul>
              <li>
                <a href="http://www.sabb.com/en/financing/personal-finance/" title="Personal Finance" target="_blank">{props.t("FOOTER_PF")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/financing/home-finance/" title="Home Finance" target="_blank">{props.t("FOOTER_HF")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/financing/finance-against-investment/" title="Financing against investments" target="_blank">{props.t("FOOTER_FIN_INVST")}</a></li>
            </ul>
          </Column>
          <Column isArabic={languageCheck.language}>
            <h2>
              <a href="http://www.sabb.com/en/payments-and-transfers/" title="Payments &amp; Transfers" data-mobile-="" target="_blank">{props.t("FOOTER_PYMT_TRNSF")}</a></h2>
            <ul>
              <li>
                <a href="http://www.sabb.com/en/payments-and-transfers/" title="Payments" target="_blank">{props.t("Payments")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/payments-and-transfers/" title="Local Transfers" target="_blank">{props.t("FOOTER_LOCL_TRNSF")}</a></li>
              <li>
                <a href="http://www.sabb.com/en/payments-and-transfers/international-transfers/" title="International Transfers" target="_blank">{props.t("FOOTER_INTN_TRANSF")}</a></li>
            </ul>
          </Column>
        </FooterMapRow>
      </FooterMap> */}
      <Grid container alignItems="center" >
        
        <FooterUtility isArabic={languageCheck.language}>
          <FooterUtilityRow>
            <ul>
              <li><a href="http://www.sabb.com/en/privacy-and-security/" title="Disclaimer" target="_blank">{props.t("Disclaimer")}</a></li>
              <li><a href="http://www.sabb.com/en/contact-us/" title="Contact Centre" target="_blank">{props.t("FOOTER_CONTCT_CNTR")}</a></li>
              <li><a href="http://www.sabb.com/en/about-sabb/about/" title="Complaints and Feedback" target="_blank">{props.t("FOOTER_COMPLN_FEEDBCK")}</a></li>
              <li><a href="http://www.sabb.com/en/sitemap/" title="Terms and Conditions" target="_blank">{props.t("FOOTER_T_C")}</a></li>
              <li><a href="http://www.sabb.com/en/contact-us/complaints-feedback/" title="About SABB" target="_blank">{props.t("FOOTER_ABT_SAB")}</a></li>
              <li><a href="http://www.sabb.com/en/term-and-conditions/" title="Sitemap" target="_blank">{props.t("Sitemap")}</a></li>
              {/* <li><a href="http://www.sabb.com/en/term-and-conditions/" title="Sitemap" target="_blank">{props.t("FOOTER_RIGHTS_RESERVD")}</a></li> */}
              {/* <p>{props.t("FOOTER_RIGHTS_RESERVD")}</p> */}
            </ul>
            <ul>
            <span>{props.t("FOOTER_RIGHTS_RESERVD")}</span>
            </ul>
          </FooterUtilityRow>
        </FooterUtility>
        
      </Grid>
    </>
  );
};

export default withTranslation()(Footer);
